
import Vue from 'vue'
import {$http} from "../../axios_api/http-common.ts"
export default Vue.extend({
    data(){
        return {
            filePath:""
        }
    },
    computed:{
        activeUser():any{
            return this.$store.getters['activeUser']
        }
    },
    methods:{
        toggleSideNav(){
            this.$router.back()
        },
        logout(){
            this.$router.push("/")
            this.$store.dispatch("logOut")
        }
    },
    mounted(){
        this.$store.commit('setSideNavToFalse')
    },
    created(){
        this.filePath = ($http as any).defaults.baseURL+"/files/userguide"
    }
})
